export default __webpack_public_path__ + "static/media/teaching-slide.aa268c1c.svg";